import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import moment from 'moment';
import CustomTooltip from '../../utils/CustomTooltip';
import { classes } from './utils';
import Toast from '../../utils/Toast';
import { resendInviteAdminOrMember } from '../../../../services/addMemberApi';
import ROLES from '../../../../constants/roles';

const createdBy = (params) => {
  const { data } = params;

  const fullName =
    data?.creator?.first_name !== undefined &&
    data?.creator?.first_name !== null &&
    data?.creator?.last_name !== undefined &&
    data?.creator?.last_name !== null
      ? `${data?.creator?.first_name} ${data?.creator?.last_name}`
      : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {fullName !== null ? fullName : '-'}
    </Typography>
  );
};

const UserRole = (params) => {
  const getRoleLabel = (userRole) => {
    if (userRole === ROLES.ADMIN) {
      return 'Admin';
    }
    if (userRole === ROLES.MANAGER) {
      return 'Manager';
    }
    return 'Member';
  };
  if (params?.data) {
    if (params?.data?.role?.role !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {getRoleLabel(params?.data?.role?.role)}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const organizationRegisteredDate = (params) => {
  const { value, data } = params;
  const formattedDate = data
    ? moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss')
    : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {formattedDate || '-'}
    </Typography>
  );
};

const ResponsiveCell = (params) => {
  const { value } = params;

  return (
    <Typography variant="body1" fontWeight={400}>
      {value !== undefined ? value : '-'}
    </Typography>
  );
};

const ActionCell = (params) => {
  const { data } = params;
  const handleResendInvitation = async () => {
    const email = data?.email;
    if (email) {
      params?.api?.purgeInfiniteCache();
      const response = await resendInviteAdminOrMember(email);
      if (response) {
        Toast({
          message: `Invitation mail resend to  ${email}`,
          variant: 'success',
        });
        return response;
      }
    }
  };
  if (data) {
    return (
      <Grid>
        <Grid container alignItems="center" justifyContent="space-between">
          <CustomTooltip title="Resend invitation">
            <Button
              onClick={handleResendInvitation}
              className={classes.sidebarToggleButtonFromNav}
            >
              Resend
            </Button>
          </CustomTooltip>
        </Grid>
      </Grid>
    );
  }
};

const invitedMembersColumnDef = (
  gridSettingData,
  gridKey,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    {
      headerName: 'Email',
      field: 'email',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      type: 'text',
      minWidth: isSmallScreen ? 200 : 250,
      maxWidth: isSmallScreen ? 250 : 350,
      pinned: isSmallScreen ? '' : 'left',
      cellRenderer: ResponsiveCell,
      filter: true,
      suppressMenu: true,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Created by',
      field: 'created_by',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 250,
      cellRenderer: createdBy,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Created at',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 250,
      cellRenderer: organizationRegisteredDate,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: 'Role',
      field: 'role',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      type: 'checkBox',
      filterParams: {
        gridKey,
        customFilterValue,
      },
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 150 : 200,
      cellRenderer: UserRole,
    },
    {
      headerName: ' ',
      field: ' ',
      headerComponent: 'ResponsiveSortingHeader',
      minWidth: isSmallScreen ? 90 : 115,
      cellRenderer: ActionCell,
    },
  ];
};

export default invitedMembersColumnDef;
